import { render } from "./TarifPage.vue?vue&type=template&id=2f2fa344"
import script from "./TarifPage.vue?vue&type=script&lang=js"
export * from "./TarifPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\PR024\\Desktop\\uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__